import {
  GET_ZIP_TIERS,
  CREATE_NEW_GET_ZIP_TIER,
  MODIFY_ZIP_TIER,
  DELETE_ZIP_TIER
} from "./actionTypes"
import { call, put, takeEvery } from "redux-saga/effects"
import {
  createNewZipTierError,
  createNewZipTierSuccess,
  deleteZipTierError,
  deleteZipTierSuccess,
  getZipTiersError,
  getZipTiersSuccess,
  modifyZipTiersError,
  modifyZipTiersSuccess,

} from "./actions"
import {
  genericDeleteRequest,
  genericGetRequest,
  genericPostRequest,
  genericPutRequest
} from "../../helpers/sf_backend_helper";

import { AppConfiguration } from "config";

function* onGetZipTiers(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/zip_tiers`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getZipTiersSuccess(response))
  } catch (error) {
    yield put(getZipTiersError(error))
  }
}

function* onCreateNewZipTier(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/zip_tiers`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(createNewZipTierSuccess(response))
  } catch (error) {
    yield put(createNewZipTierError(error))
  }
}

function* onModifyZipTier(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/zip_tiers/${action?.payload?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(modifyZipTiersSuccess(response))
  } catch (error) {
    yield put(modifyZipTiersError(error))
  }
}

function* onDeleteZipTier(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/zip_tiers/${action?.payload?.id}`,
      {
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteZipTierSuccess(response))
  } catch (error) {
    yield put(deleteZipTierError(error))
  }
}

function* ZipTiersSaga() {
  yield takeEvery(GET_ZIP_TIERS, onGetZipTiers)
  yield takeEvery(CREATE_NEW_GET_ZIP_TIER, onCreateNewZipTier)
  yield takeEvery(MODIFY_ZIP_TIER, onModifyZipTier)
  yield takeEvery(DELETE_ZIP_TIER, onDeleteZipTier)
}


export default ZipTiersSaga;
